import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Agent, BankDetails, Organization, OrganizationClient, ServiceProvider } from "src/app/web-api-client";
import { OrganizationalTypes } from "../../../../enums/organizational-types.enum";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { forkJoin, Subject } from "rxjs";
import { ServiceRequestResponseTypes } from "../../../../shared/enum/serviceRequestResponseTypes.enum";
import { ServiceRequestResponseTypeUtil } from "../../../../shared/utils/service-request-response.utils";

@Component({
  selector: 'app-org-creation',
  templateUrl: './org-creation.component.html',
  styleUrls: ['./org-creation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrgCreationComponent implements OnInit {

  public isChildSelected: boolean = false;
  public isServiceProviderEnabled: boolean = false;
  public enableVik: boolean = false;

  public onClose = new Subject<boolean>();
  public agents: Agent[] = [];
  public providers: ServiceProvider[] = [];
  public selectedBankAccount: BankDetails; 
  public responseTypes = Object.keys(ServiceRequestResponseTypes)
    .filter(key => !isNaN(Number(ServiceRequestResponseTypes[key])))
    .map(key => ({ name: key, value: ServiceRequestResponseTypes[key] }));


  public isLoaded = true;
  public organizations: Organization[];
  public OrganizationalTypes = OrganizationalTypes;
  public orgTypes = Object.keys(OrganizationalTypes).filter(
    key => !isNaN(Number(OrganizationalTypes[key]))
  );

  Form: FormGroup;

  constructor(private fb: FormBuilder,public _cdr:ChangeDetectorRef, public activeModal: NgbActiveModal, public orgClient: OrganizationClient) { }

  ngOnInit(): void {

    this.isLoaded = false;
    forkJoin(this.orgClient.getProviders(), this.orgClient.getAgentss())
      .subscribe(([providers, agents]) => {
        this.agents = agents;
        this.providers = providers;
        this.isLoaded = true;
        this.initializeForm();
      })

  }

  initializeForm() {
    this.Form = this.fb.group({
      title: ['', Validators.required],
      vat: ['', Validators.required],
      enableVik:[this.enableVik, Validators.required],
      description: ['', Validators.required],
      orgType: [OrganizationalTypes.Client, Validators.required],
      selectedProvider: [0, Validators.required],
      selectedAgent: [0, Validators.required],
      parentChildOrg: ['parent'],  // Default value set to 'parent'
      parentOrg: [null],
      responseType:[0]
    });

    this._cdr.detectChanges();
  }

  onOrgTypeChange(type: string) {
    if (type === 'child') {
      this.isChildSelected = true;
    } else {
      this.isChildSelected = false;
      this.Form.controls['parentChildOrg'].setValue(null);  // Reset the parent organization value
    }

    this._cdr.detectChanges();
  }


  onSubmit() {
    if (this.Form.valid) {

      let newUser = new Organization();

      newUser.id = 0;
      newUser.title = this.Form.value.title;
      newUser.vat = this.Form.value.vat;
      newUser.description = this.Form.value.description;
      newUser.organizationalType = this.Form.value.orgType;
      newUser.url = ' ';
      newUser.avatar = 'noAvatar.png';
      newUser.agentId = this.Form.value.selectedAgent;
      newUser.serviceProviderId = this.Form.value.selectedProvider;
      newUser.parentOrganizationId = this.Form.value.parentOrg;
      newUser.idBankDetails = this.selectedBankAccount.idBankDetails;
      newUser.enableServiceProvider = this.isServiceProviderEnabled;
      newUser.enableVikModule = this.enableVik;
      newUser.notificationType = +this.Form.value.responseType;

      this.orgClient.create(newUser).subscribe((user) => {
        this.onClose.next(true);
        this.activeModal.close();
      });
    }
  }

  onBankAccountSelected(bankAccount: BankDetails) {
    this.selectedBankAccount = bankAccount;
  }

  closeModal() {
    this.onClose.next(true);
    this.activeModal.close();
  }
  onCheckboxChange() {

    this.isServiceProviderEnabled = !this.isServiceProviderEnabled;
    this._cdr.detectChanges();
  }

  onVikChange() {

    this.enableVik = !this.enableVik;
    this._cdr.detectChanges();
  }

  public GetCyrilicRequestType(requestType: ServiceRequestResponseTypes): string {

    return ServiceRequestResponseTypeUtil.getCyrilicLabel(requestType);
  }

 
}
